import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Narrow Content",
  tags: ["#page"],
}

export default defineBlock("content/narrow-content", (props) => {
  return (
    <div
      className={cn(
        "narrow-content w-full my-9 md:max-w-blogPostTextW block-padding mx-auto [&_.wp-block-heading]:mt-5 [&_h1]:!type-header-xl [&_h2]:!type-header-l [&_h3]:!type-header-m [&_h4]:!type-header-s [&_p]:!type-body-m [&_li]:!type-body-m [&_.quote-title]:!type-header-l [&_.quote]:my-6 [&_strong]:font-[500] [&_p_a]:!underline [&_p_a]:!font-normal",
        !env.admin && "flex flex-col gap-4",
      )}
    >
      <InnerBlocks
        allowedBlocks={["#inline"]}
        adminClassName="flex flex-col gap-4"
        template={[["core/paragraph", { placeholder: "Enter some text" }]]}
      />
    </div>
  )
})
